export enum InvoiceType {
  ONETIME = 'OneTime',
  AZUREUSAGE = 'AzureUsage',
  CONSOLIDATED = 'Consolidated',
  ONDEMEND = 'OnDemand',
  RECURRING = 'Recurring',
}
